export const ROLE_LABELS = {
  admin: "Admin",
  medico: "Médico",
  enfermeira_prescritora: "Enfermeira | Tricologia",
  secretaria: "Secretaria",
  enfermagem: "Enfermagem",
};

export function hasMedicalAccess(role) {
  return role === "medico" || role === "enfermeira_prescritora";
}

export function hasAdminAccess(role) {
  return role === "admin" || hasMedicalAccess(role);
}

export function canManageHairProcedurePayments(role) {
  return role === "admin" || role === "secretaria" || role === "medico" || role === "enfermeira_prescritora";
}

export function roleLabel(role) {
  return ROLE_LABELS[role] || role;
}